import type { MediaPost, MediaTrack } from '@/lib/media';

export interface DemoVideo extends MediaPost {
  demo: true;
}

export interface DemoTrack extends MediaTrack {
  demo: true;
}

export const demoVideos: DemoVideo[] = [
  {
    id: 'real-v-1',
    owner_id: 'featured',
    title: 'DINGO (Clip Officiel)',
    description: "Le nouveau clip de Santrinos Raphael, l'étoile de l'AfroRnB togolais.",
    category: 'Musique',
    video_url: 'https://www.youtube.com/watch?v=w_Y__ieCwDk',
    thumbnail_url: 'https://img.youtube.com/vi/w_Y__ieCwDk/hqdefault.jpg',
    artist_name: 'Santrinos Raphael',
    location: 'Lomé, Togo',
    views: 2100000,
    likes: 198000,
    status: 'active',
    created_at: '2026-08-19',
    demo: true,
  },
  {
    id: 'real-v-2',
    owner_id: 'featured',
    title: 'Bougez Là-bas (Official Music Video)',
    description: 'Santrinos Raphael vous fait bouger avec ce titre entêtant et ensoleillé.',
    category: 'Musique',
    video_url: 'https://www.youtube.com/watch?v=lUe1SorRjhI',
    thumbnail_url: 'https://img.youtube.com/vi/lUe1SorRjhI/hqdefault.jpg',
    artist_name: 'Santrinos Raphael',
    location: 'Lomé, Togo',
    views: 868000,
    likes: 82000,
    status: 'active',
    created_at: '2026-08-18',
    demo: true,
  },
  {
    id: 'real-v-3',
    owner_id: 'featured',
    title: 'Business Class (Clip Officiel)',
    description: 'Le tube de Kiko, le « Golden Boy » de la scène pop togolaise.',
    category: 'Musique',
    video_url: 'https://www.youtube.com/watch?v=6MEhlDvRi1Y',
    thumbnail_url: 'https://img.youtube.com/vi/6MEhlDvRi1Y/hqdefault.jpg',
    artist_name: 'Kiko Golden Boy',
    location: 'Lomé, Togo',
    views: 288000,
    likes: 31000,
    status: 'active',
    created_at: '2026-08-17',
    demo: true,
  },
  {
    id: 'real-v-4',
    owner_id: 'featured',
    title: 'Vamidjo (Official Music Video)',
    description: 'Santrinos Raphael — un clip envoûtant signé Belifornia Record.',
    category: 'Musique',
    video_url: 'https://www.youtube.com/watch?v=LQUOkoSsjM4',
    thumbnail_url: 'https://img.youtube.com/vi/LQUOkoSsjM4/hqdefault.jpg',
    artist_name: 'Santrinos Raphael',
    location: 'Lomé, Togo',
    views: 948000,
    likes: 88000,
    status: 'active',
    created_at: '2026-08-16',
    demo: true,
  },
  {
    id: 'demo-v-1',
    owner_id: 'demo',
    title: 'Chorégraphie afrobeat — danse du moment',
    description: 'Nouvelle chorégraphie afrobeat, apprenez les pas avec moi !',
    category: 'Danse',
    video_url:
      'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4',
    thumbnail_url:
      'https://readdy.ai/api/search-image?query=Young%20African%20dancers%20performing%20an%20energetic%20afrobeat%20choreography%20in%20a%20vibrant%20studio%2C%20colorful%20clothing%2C%20dynamic%20motion%2C%20warm%20golden%20lighting%2C%20professional%20dance%20video%20thumbnail%2C%20rich%20warm%20tones&width=1280&height=720&seq=media-video-1&orientation=landscape',
    artist_name: 'Ama Kodjo',
    location: 'Lomé, Togo',
    views: 48200,
    likes: 5300,
    status: 'active',
    created_at: '2026-08-19',
    demo: true,
  },
  {
    id: 'demo-v-2',
    owner_id: 'demo',
    title: 'Session djembé en live — rythmes traditionnels',
    description: 'Un moment de partage autour du djembé et des rythmes ancestraux.',
    category: 'Musique',
    video_url:
      'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerEscapes.mp4',
    thumbnail_url:
      'https://readdy.ai/api/search-image?query=Traditional%20African%20djembe%20drummers%20performing%20live%20in%20a%20circle%2C%20warm%20sunset%20light%2C%20colorful%20traditional%20clothing%2C%20joyful%20rhythm%20session%2C%20professional%20video%20thumbnail%2C%20warm%20earthy%20tones&width=1280&height=720&seq=media-video-2&orientation=landscape',
    artist_name: 'Groupe Kinkéliba',
    location: 'Kara, Togo',
    views: 31500,
    likes: 4100,
    status: 'active',
    created_at: '2026-08-18',
    demo: true,
  },
  {
    id: 'demo-v-3',
    owner_id: 'demo',
    title: 'Sketch : la vie quotidienne à Lomé',
    description: 'Un regard drôle et tendre sur le quotidien à Lomé. 😄',
    category: 'Comédie',
    video_url:
      'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerFun.mp4',
    thumbnail_url:
      'https://readdy.ai/api/search-image?query=African%20comedian%20performing%20a%20funny%20sketch%20on%20a%20colorful%20street%20scene%2C%20expressive%20gestures%2C%20bright%20daylight%2C%20lively%20urban%20atmosphere%2C%20professional%20video%20thumbnail%2C%20warm%20vibrant%20tones&width=1280&height=720&seq=media-video-3&orientation=landscape',
    artist_name: 'Désiré Amouzou',
    location: 'Lomé, Togo',
    views: 89300,
    likes: 12400,
    status: 'active',
    created_at: '2026-08-17',
    demo: true,
  },
  {
    id: 'demo-v-4',
    owner_id: 'demo',
    title: 'Tutoriel : fabriquer un panier en raphia',
    description: 'Étape par étape, apprenez à tisser un panier traditionnel.',
    category: 'Tutoriel',
    video_url:
      'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerJoyrides.mp4',
    thumbnail_url:
      'https://readdy.ai/api/search-image?query=Hands%20weaving%20a%20traditional%20raffia%20basket%20step%20by%20step%20in%20a%20bright%20artisan%20workshop%2C%20warm%20natural%20light%2C%20close-up%20craftsmanship%2C%20professional%20tutorial%20video%20thumbnail%2C%20warm%20earthy%20tones&width=1280&height=720&seq=media-video-4&orientation=landscape',
    artist_name: 'Atelier Kossi',
    location: 'Kpalimé, Togo',
    views: 15600,
    likes: 2100,
    status: 'active',
    created_at: '2026-08-16',
    demo: true,
  },
  {
    id: 'demo-v-5',
    owner_id: 'demo',
    title: 'Look wax du jour — tenue sur mesure',
    description: 'Découvrez ma création wax du jour, du tissu à la tenue finale.',
    category: 'Mode & Wax',
    video_url:
      'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerMeltdowns.mp4',
    thumbnail_url:
      'https://readdy.ai/api/search-image?query=Elegant%20African%20fashion%20model%20showing%20a%20vibrant%20wax%20print%20outfit%2C%20colorful%20patterns%2C%20warm%20studio%20lighting%2C%20gold%20accessories%2C%20professional%20fashion%20video%20thumbnail%2C%20rich%20warm%20tones&width=1280&height=720&seq=media-video-5&orientation=landscape',
    artist_name: 'Adjoa Mensah',
    location: 'Cotonou, Bénin',
    views: 27800,
    likes: 3600,
    status: 'active',
    created_at: '2026-08-15',
    demo: true,
  },
  {
    id: 'demo-v-6',
    owner_id: 'demo',
    title: 'Recette : fufu & sauce d\'arachide',
    description: 'La vraie recette du fufu maison avec une sauce onctueuse.',
    category: 'Gastronomie',
    video_url:
      'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4',
    thumbnail_url:
      'https://readdy.ai/api/search-image?query=African%20chef%20cooking%20fufu%20and%20peanut%20sauce%20in%20a%20rustic%20kitchen%2C%20steam%20rising%2C%20fresh%20ingredients%2C%20warm%20ambient%20light%2C%20professional%20cooking%20video%20thumbnail%2C%20rich%20warm%20tones&width=1280&height=720&seq=media-video-6&orientation=landscape',
    artist_name: 'Chef Ama',
    location: 'Lomé, Togo',
    views: 42100,
    likes: 5900,
    status: 'active',
    created_at: '2026-08-14',
    demo: true,
  },
  {
    id: 'real-v-5',
    owner_id: 'featured',
    title: 'GWETA (Official HD)',
    description: 'Le tube légendaire du duo Toofan qui a fait danser toute l\u2019Afrique.',
    category: 'Musique',
    video_url: 'https://www.youtube.com/watch?v=RJ2e_V_2XAk',
    thumbnail_url: 'https://img.youtube.com/vi/RJ2e_V_2XAk/hqdefault.jpg',
    artist_name: 'Toofan',
    location: 'Lomé, Togo',
    views: 22000000,
    likes: 210000,
    status: 'active',
    created_at: '2026-08-13',
    demo: true,
  },
  {
    id: 'real-v-6',
    owner_id: 'featured',
    title: 'Monica (ft. Stonebwoy)',
    description: 'Santrinos Raphael et Stonebwoy réunis pour un duo inoubliable.',
    category: 'Musique',
    video_url: 'https://www.youtube.com/watch?v=Z8g2Rw6BbSQ',
    thumbnail_url: 'https://img.youtube.com/vi/Z8g2Rw6BbSQ/hqdefault.jpg',
    artist_name: 'Santrinos Raphael',
    location: 'Lomé, Togo',
    views: 6700000,
    likes: 43000,
    status: 'active',
    created_at: '2026-08-12',
    demo: true,
  },
  {
    id: 'real-v-7',
    owner_id: 'featured',
    title: 'Agbéa Dé Fu (ft. King Mensah)',
    description: 'Santrinos Raphael et la voix d\u2019or du Togo, King Mensah, en duo.',
    category: 'Musique',
    video_url: 'https://www.youtube.com/watch?v=C_PPluXYI4c',
    thumbnail_url: 'https://img.youtube.com/vi/C_PPluXYI4c/hqdefault.jpg',
    artist_name: 'King Mensah',
    location: 'Lomé, Togo',
    views: 1800000,
    likes: 27000,
    status: 'active',
    created_at: '2026-08-11',
    demo: true,
  },
  {
    id: 'real-v-8',
    owner_id: 'featured',
    title: 'GNAWO (Official Video)',
    description: 'Le nouveau banger de Joachim Migos, la révélation du rap togolais.',
    category: 'Musique',
    video_url: 'https://www.youtube.com/watch?v=1yuZvsJh_lU',
    thumbnail_url: 'https://img.youtube.com/vi/1yuZvsJh_lU/hqdefault.jpg',
    artist_name: 'Joachim Migos',
    location: 'Lomé, Togo',
    views: 531000,
    likes: 42000,
    status: 'active',
    created_at: '2026-08-10',
    demo: true,
  },
  {
    id: 'real-v-9',
    owner_id: 'featured',
    title: 'ÉVÉNAMI (ft. Mic Flammez)',
    description: 'Joachim Migos et Mic Flammez réunis pour un duo rap qui enflamme.',
    category: 'Musique',
    video_url: 'https://www.youtube.com/watch?v=wwLIjn7FQ1U',
    thumbnail_url: 'https://img.youtube.com/vi/wwLIjn7FQ1U/hqdefault.jpg',
    artist_name: 'Joachim Migos',
    location: 'Lomé, Togo',
    views: 349000,
    likes: 28000,
    status: 'active',
    created_at: '2026-08-09',
    demo: true,
  },
  {
    id: 'real-v-10',
    owner_id: 'featured',
    title: 'ESSOME (Official Video)',
    description: 'Mic Flammez, le Président du Rap Game togolais, frappe fort.',
    category: 'Musique',
    video_url: 'https://www.youtube.com/watch?v=VX06cy4NCyA',
    thumbnail_url: 'https://img.youtube.com/vi/VX06cy4NCyA/hqdefault.jpg',
    artist_name: 'Mic Flammez',
    location: 'Lomé, Togo',
    views: 1200000,
    likes: 96000,
    status: 'active',
    created_at: '2026-08-08',
    demo: true,
  },
  {
    id: 'real-v-11',
    owner_id: 'featured',
    title: 'VENADOME (clip officiel)',
    description: 'Sethlo, la star de l\u2019Éwoubo Republic, livre un hit imparable.',
    category: 'Musique',
    video_url: 'https://www.youtube.com/watch?v=aG8kdddSDrY',
    thumbnail_url: 'https://img.youtube.com/vi/aG8kdddSDrY/hqdefault.jpg',
    artist_name: 'Sethlo',
    location: 'Lomé, Togo',
    views: 940000,
    likes: 81000,
    status: 'active',
    created_at: '2026-08-07',
    demo: true,
  },
  {
    id: 'real-v-12',
    owner_id: 'featured',
    title: 'C\u2019est du mélange (clip officiel)',
    description: 'Sethlo mélange les genres et fait danser tout le Togo.',
    category: 'Musique',
    video_url: 'https://www.youtube.com/watch?v=hylmEMbu47I',
    thumbnail_url: 'https://img.youtube.com/vi/hylmEMbu47I/hqdefault.jpg',
    artist_name: 'Sethlo',
    location: 'Lomé, Togo',
    views: 226000,
    likes: 19000,
    status: 'active',
    created_at: '2026-08-06',
    demo: true,
  },
  {
    id: 'real-v-13',
    owner_id: 'featured',
    title: 'Amédé (Official Music Video)',
    description: 'Ralycia, la voix montante de la scène togolaise, et son tube à 1,8M de vues.',
    category: 'Musique',
    video_url: 'https://www.youtube.com/watch?v=oaumEzQTZ2c',
    thumbnail_url: 'https://img.youtube.com/vi/oaumEzQTZ2c/hqdefault.jpg',
    artist_name: 'Ralycia',
    location: 'Kara, Togo',
    views: 1800000,
    likes: 150000,
    status: 'active',
    created_at: '2026-08-05',
    demo: true,
  },
  {
    id: 'real-v-14',
    owner_id: 'featured',
    title: 'Nulaké (Official Music Video)',
    description: 'Ralycia — un titre afropop tout en douceur et en émotion.',
    category: 'Musique',
    video_url: 'https://www.youtube.com/watch?v=ZT0K9eHdhMM',
    thumbnail_url: 'https://img.youtube.com/vi/ZT0K9eHdhMM/hqdefault.jpg',
    artist_name: 'Ralycia',
    location: 'Kara, Togo',
    views: 412000,
    likes: 36000,
    status: 'active',
    created_at: '2026-08-04',
    demo: true,
  },
  {
    id: 'real-v-15',
    owner_id: 'featured',
    title: 'LONLON (ft. Laura Bazooka)',
    description: 'Pikaluz et Laura Bazooka — le duo rap qui cartonne.',
    category: 'Musique',
    video_url: 'https://www.youtube.com/watch?v=VLEKKnIJuOg',
    thumbnail_url: 'https://img.youtube.com/vi/VLEKKnIJuOg/hqdefault.jpg',
    artist_name: 'Pikaluz',
    location: 'Lomé, Togo',
    views: 849000,
    likes: 71000,
    status: 'active',
    created_at: '2026-08-03',
    demo: true,
  },
  {
    id: 'real-v-16',
    owner_id: 'featured',
    title: 'SOMÉ (ft. Santrinos Raphael)',
    description: 'Pikaluz et Santrinos Raphael signent un morceau événement.',
    category: 'Musique',
    video_url: 'https://www.youtube.com/watch?v=VMnVDGm8AXs',
    thumbnail_url: 'https://img.youtube.com/vi/VMnVDGm8AXs/hqdefault.jpg',
    artist_name: 'Pikaluz',
    location: 'Lomé, Togo',
    views: 510000,
    likes: 44000,
    status: 'active',
    created_at: '2026-08-02',
    demo: true,
  },
  {
    id: 'real-v-17',
    owner_id: 'featured',
    title: 'Nobody (clip officiel)',
    description: 'Laura Bazooka, la rappeuse qui impose son style unique.',
    category: 'Musique',
    video_url: 'https://www.youtube.com/watch?v=CPYC2k_hhzg',
    thumbnail_url: 'https://img.youtube.com/vi/CPYC2k_hhzg/hqdefault.jpg',
    artist_name: 'Laura Bazooka',
    location: 'Lomé, Togo',
    views: 680000,
    likes: 55000,
    status: 'active',
    created_at: '2026-08-01',
    demo: true,
  },
  {
    id: 'real-v-18',
    owner_id: 'featured',
    title: 'Kplagnance (Official Video)',
    description: 'Anodaboy, la sensation afrobeats/afropop du moment.',
    category: 'Musique',
    video_url: 'https://www.youtube.com/watch?v=3tL8XN2UDMY',
    thumbnail_url: 'https://img.youtube.com/vi/3tL8XN2UDMY/hqdefault.jpg',
    artist_name: 'Anodaboy',
    location: 'Lomé, Togo',
    views: 720000,
    likes: 58000,
    status: 'active',
    created_at: '2026-07-31',
    demo: true,
  },
  {
    id: 'real-v-19',
    owner_id: 'featured',
    title: 'Gabara 4 You (Official Video)',
    description: 'Anodaboy — un morceau énergique et dansant qui tourne en boucle.',
    category: 'Musique',
    video_url: 'https://www.youtube.com/watch?v=-iroQ5wF_AU',
    thumbnail_url: 'https://img.youtube.com/vi/-iroQ5wF_AU/hqdefault.jpg',
    artist_name: 'Anodaboy',
    location: 'Lomé, Togo',
    views: 305000,
    likes: 26000,
    status: 'active',
    created_at: '2026-07-30',
    demo: true,
  },
  {
    id: 'real-v-20',
    owner_id: 'featured',
    title: 'Gbona (Official Music Video)',
    description: 'Burna Boy, la superstar nigériane, enflamme les charts mondiaux.',
    category: 'Musique',
    video_url: 'https://www.youtube.com/watch?v=h7WfPHHXCAY',
    thumbnail_url: 'https://img.youtube.com/vi/h7WfPHHXCAY/hqdefault.jpg',
    artist_name: 'Burna Boy',
    location: 'Lagos, Nigeria',
    views: 48000000,
    likes: 520000,
    status: 'active',
    created_at: '2026-07-29',
    demo: true,
  },
  {
    id: 'real-v-21',
    owner_id: 'featured',
    title: 'Yaya (feat. Aya Nakamura)',
    description: 'Davido et Aya Nakamura réunis pour un duo afropop mondial.',
    category: 'Musique',
    video_url: 'https://www.youtube.com/watch?v=_b12oPrxprM',
    thumbnail_url: 'https://img.youtube.com/vi/_b12oPrxprM/hqdefault.jpg',
    artist_name: 'Davido',
    location: 'Paris, France',
    views: 25000000,
    likes: 310000,
    status: 'active',
    created_at: '2026-07-28',
    demo: true,
  },
  {
    id: 'real-v-22',
    owner_id: 'featured',
    title: 'TOUT IRA MIEUX [FAUT PAS M\u2019APPELER] (Clip Officiel)',
    description: 'Paki Chenzu, la révélation rap togolaise, et son clip à plus de 4 millions de vues.',
    category: 'Musique',
    video_url: 'https://www.youtube.com/watch?v=8GCtSxewbgM',
    thumbnail_url: 'https://img.youtube.com/vi/8GCtSxewbgM/hqdefault.jpg',
    artist_name: 'Paki Chenzu',
    location: 'Lomé, Togo',
    views: 4200000,
    likes: 320000,
    status: 'active',
    created_at: '2026-07-27',
    demo: true,
  },
  {
    id: 'real-v-23',
    owner_id: 'featured',
    title: 'KIRA 5 (Clip Officiel)',
    description: 'Paki Chenzu dégaine un nouveau banger aux punchlines percutantes.',
    category: 'Musique',
    video_url: 'https://www.youtube.com/watch?v=c00T_ywXmo4',
    thumbnail_url: 'https://img.youtube.com/vi/c00T_ywXmo4/hqdefault.jpg',
    artist_name: 'Paki Chenzu',
    location: 'Lomé, Togo',
    views: 980000,
    likes: 81000,
    status: 'active',
    created_at: '2026-07-26',
    demo: true,
  },
  {
    id: 'real-v-24',
    owner_id: 'featured',
    title: 'TAGA GBEGBLE (Clip Officiel)',
    description: 'Ghettovi, le 1er rappeur togolais certifié, signe un retour fracassant.',
    category: 'Musique',
    video_url: 'https://www.youtube.com/watch?v=36QwPO9OsGw',
    thumbnail_url: 'https://img.youtube.com/vi/36QwPO9OsGw/hqdefault.jpg',
    artist_name: 'Ghettovi',
    location: 'Lomé, Togo',
    views: 760000,
    likes: 63000,
    status: 'active',
    created_at: '2026-07-25',
    demo: true,
  },
  {
    id: 'real-v-25',
    owner_id: 'featured',
    title: 'Agbo (Official Video)',
    description: 'Ghettovi, membre du collectif GMG, livre un clip intense et authentique.',
    category: 'Musique',
    video_url: 'https://www.youtube.com/watch?v=tj4DPIU5rRE',
    thumbnail_url: 'https://img.youtube.com/vi/tj4DPIU5rRE/hqdefault.jpg',
    artist_name: 'Ghettovi',
    location: 'Lomé, Togo',
    views: 460000,
    likes: 39000,
    status: 'active',
    created_at: '2026-07-24',
    demo: true,
  },
];

export const demoTracks: DemoTrack[] = [
  {
    id: 'real-t-1',
    owner_id: 'featured',
    title: "Maladie d'amour",
    artist_name: 'Santrinos Raphael',
    category: 'Musique',
    audio_url: 'https://www.youtube.com/watch?v=ZIuClhXg9aU',
    cover_url: 'https://img.youtube.com/vi/ZIuClhXg9aU/hqdefault.jpg',
    duration: 179,
    plays: 29000000,
    likes: 410000,
    location: 'Lomé, Togo',
    status: 'active',
    created_at: '2026-08-19',
    demo: true,
  },
  {
    id: 'real-t-2',
    owner_id: 'featured',
    title: 'Vamidjo',
    artist_name: 'Santrinos Raphael',
    category: 'Musique',
    audio_url: 'https://www.youtube.com/watch?v=LQUOkoSsjM4',
    cover_url: 'https://img.youtube.com/vi/LQUOkoSsjM4/hqdefault.jpg',
    duration: 195,
    plays: 948000,
    likes: 88000,
    location: 'Lomé, Togo',
    status: 'active',
    created_at: '2026-08-18',
    demo: true,
  },
  {
    id: 'real-t-3',
    owner_id: 'featured',
    title: 'Business Class',
    artist_name: 'Kiko Golden Boy',
    category: 'Musique',
    audio_url: 'https://www.youtube.com/watch?v=6MEhlDvRi1Y',
    cover_url: 'https://img.youtube.com/vi/6MEhlDvRi1Y/hqdefault.jpg',
    duration: 210,
    plays: 288000,
    likes: 31000,
    location: 'Lomé, Togo',
    status: 'active',
    created_at: '2026-08-17',
    demo: true,
  },
  {
    id: 'real-t-4',
    owner_id: 'featured',
    title: 'Cette Vie',
    artist_name: 'Kiko Golden Boy',
    category: 'Musique',
    audio_url: 'https://www.youtube.com/watch?v=JitgdcEP1eY',
    cover_url: 'https://img.youtube.com/vi/JitgdcEP1eY/hqdefault.jpg',
    duration: 188,
    plays: 150000,
    likes: 16000,
    location: 'Lomé, Togo',
    status: 'active',
    created_at: '2026-08-16',
    demo: true,
  },
  {
    id: 'real-t-5',
    owner_id: 'featured',
    title: 'Tchaka',
    artist_name: 'Kiko Golden Boy',
    category: 'Musique',
    audio_url: 'https://www.youtube.com/watch?v=VrMFErFDjtk',
    cover_url: 'https://img.youtube.com/vi/VrMFErFDjtk/hqdefault.jpg',
    duration: 201,
    plays: 180000,
    likes: 19000,
    location: 'Lomé, Togo',
    status: 'active',
    created_at: '2026-08-15',
    demo: true,
  },
  {
    id: 'real-t-6',
    owner_id: 'featured',
    title: 'Nononini',
    artist_name: 'Almok',
    category: 'Musique',
    audio_url: 'https://www.youtube.com/watch?v=PzS9kC_S0WE',
    cover_url: 'https://img.youtube.com/vi/PzS9kC_S0WE/hqdefault.jpg',
    duration: 176,
    plays: 500000,
    likes: 52000,
    location: 'Lomé, Togo',
    status: 'active',
    created_at: '2026-08-14',
    demo: true,
  },
  {
    id: 'real-t-7',
    owner_id: 'featured',
    title: 'Pas à Pas (ft. Kiko Golden Boy)',
    artist_name: 'Etane Blex',
    category: 'Musique',
    audio_url: 'https://www.youtube.com/watch?v=03Iow-3oO0c',
    cover_url: 'https://img.youtube.com/vi/03Iow-3oO0c/hqdefault.jpg',
    duration: 185,
    plays: 300000,
    likes: 27000,
    location: 'Lomé, Togo',
    status: 'active',
    created_at: '2026-08-13',
    demo: true,
  },
  {
    id: 'demo-t-1',
    owner_id: 'demo',
    title: 'Aké',
    artist_name: 'Ama Kodjo',
    category: 'Musique',
    audio_url: 'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3',
    cover_url:
      'https://readdy.ai/api/search-image?query=Abstract%20afrobeat%20album%20cover%20with%20vibrant%20African%20patterns%20and%20warm%20golden%20geometric%20shapes%2C%20rich%20terracotta%20and%20amber%20tones%2C%20modern%20music%20art%2C%20professional%20design&width=600&height=600&seq=media-track-1&orientation=squarish',
    duration: 312,
    plays: 85000,
    likes: 12000,
    location: 'Lomé, Togo',
    status: 'active',
    created_at: '2026-08-19',
    demo: true,
  },
  {
    id: 'demo-t-2',
    owner_id: 'demo',
    title: 'Rythmes du Golfe',
    artist_name: 'Groupe Kinkéliba',
    category: 'Musique',
    audio_url: 'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-2.mp3',
    cover_url:
      'https://readdy.ai/api/search-image?query=Traditional%20African%20drum%20ensemble%20album%20cover%2C%20warm%20sunset%20tones%2C%20djembe%20drums%20silhouettes%2C%20earthy%20colors%2C%20professional%20music%20artwork%2C%20rich%20warm%20gradients&width=600&height=600&seq=media-track-2&orientation=squarish',
    duration: 284,
    plays: 64000,
    likes: 8900,
    location: 'Kara, Togo',
    status: 'active',
    created_at: '2026-08-18',
    demo: true,
  },
  {
    id: 'demo-t-3',
    owner_id: 'demo',
    title: 'Souvenirs',
    artist_name: 'Kossi Mensah',
    category: 'Musique',
    audio_url: 'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-3.mp3',
    cover_url:
      'https://readdy.ai/api/search-image?query=Melancholic%20acoustic%20African%20ballad%20album%20cover%2C%20warm%20golden%20light%2C%20soft%20textures%2C%20minimalist%20modern%20music%20art%2C%20professional%20design%2C%20rich%20amber%20tones&width=600&height=600&seq=media-track-3&orientation=squarish',
    duration: 245,
    plays: 41000,
    likes: 5600,
    location: 'Accra, Ghana',
    status: 'active',
    created_at: '2026-08-17',
    demo: true,
  },
  {
    id: 'demo-t-4',
    owner_id: 'demo',
    title: 'Djoliba Flow',
    artist_name: 'Moussa Diallo',
    category: 'Musique',
    audio_url: 'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-4.mp3',
    cover_url:
      'https://readdy.ai/api/search-image?query=Modern%20afrobeat%20rap%20album%20cover%20with%20bold%20typography%20and%20warm%20African%20color%20palette%2C%20vibrant%20geometric%20shapes%2C%20professional%20music%20artwork%2C%20rich%20terracotta%20tones&width=600&height=600&seq=media-track-4&orientation=squarish',
    duration: 198,
    plays: 97000,
    likes: 15400,
    location: 'Bamako, Mali',
    status: 'active',
    created_at: '2026-08-16',
    demo: true,
  },
  {
    id: 'demo-t-5',
    owner_id: 'demo',
    title: 'Lumière d\'Afrique',
    artist_name: 'Adjoa Mensah',
    category: 'Musique',
    audio_url: 'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-5.mp3',
    cover_url:
      'https://readdy.ai/api/search-image?query=Soulful%20African%20female%20vocalist%20album%20cover%2C%20warm%20golden%20portrait%20silhouette%2C%20elegant%20minimalist%20design%2C%20professional%20music%20artwork%2C%20rich%20amber%20and%20gold%20tones&width=600&height=600&seq=media-track-5&orientation=squarish',
    duration: 276,
    plays: 52000,
    likes: 7300,
    location: 'Cotonou, Bénin',
    status: 'active',
    created_at: '2026-08-15',
    demo: true,
  },
  {
    id: 'demo-t-6',
    owner_id: 'demo',
    title: 'Balafon Dreams',
    artist_name: 'Yao Amegnaglo',
    category: 'Musique',
    audio_url: 'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-6.mp3',
    cover_url:
      'https://readdy.ai/api/search-image?query=Traditional%20balafon%20instrument%20album%20cover%2C%20warm%20sunset%20gradient%2C%20wooden%20textures%2C%20minimalist%20African%20music%20artwork%2C%20professional%20design%2C%20rich%20earthy%20tones&width=600&height=600&seq=media-track-6&orientation=squarish',
    duration: 230,
    plays: 33000,
    likes: 4100,
    location: 'Ouagadougou, Burkina Faso',
    status: 'active',
    created_at: '2026-08-14',
    demo: true,
  },
];